function getApiBase() {
    const raw =
        process.env.REACT_APP_API_URL ||
        process.env.REACT_APP_NODE_API_URL ||
        '';
    return String(raw).replace(/^['"]|['"]$/g, '').replace(/\/$/, '');
}

export function toRelativeMediaPath(value) {
    if (value == null || value === '') {
        return value;
    }
    const str = String(value).trim();
    if (!str) {
        return str;
    }
    if (str.startsWith('/uploads/') || str.startsWith('/image/')) {
        return str;
    }
    if (/^https?:\/\//i.test(str)) {
        try {
            const pathname = new URL(str).pathname;
            if (pathname.startsWith('/uploads/') || pathname.startsWith('/image/')) {
                return pathname;
            }
        } catch {
            // ignore
        }
    }
    return str;
}

export function resolveMediaUrl(value) {
    if (value == null || value === '') {
        return value;
    }
    if (typeof value !== 'string') {
        return value;
    }
    const str = value.trim();
    if (!str) {
        return str;
    }
    if (
        str.startsWith('data:') ||
        str.startsWith('blob:') ||
        str.startsWith('/static/')
    ) {
        return value;
    }
    const relative = toRelativeMediaPath(str);
    if (relative.startsWith('/uploads/') || relative.startsWith('/image/')) {
        const base = getApiBase();
        return base ? `${base}${relative}` : relative;
    }
    if (/^https?:\/\//i.test(str)) {
        return str;
    }
    return value;
}

export function resolveMediaCssUrl(value) {
    const resolved = resolveMediaUrl(value);
    if (resolved == null || resolved === '') {
        return '';
    }
    return String(resolved).replace(/"/g, '\\"');
}
